// laneB.ts — Patch 010.A.4 R7 split. Lane B AI run trigger.

import { request } from './request'
import type { LaneBRunResponse } from './types'

export const laneBApi = {
  run: (projectId: string) =>
    request<LaneBRunResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/lane-b/run`,
      { method: 'POST', body: JSON.stringify({}) },
    ),
}
